module.exports = __webpack_public_path__ + "img/lageplan_640.d687f4e3.jpg";